import type { AppRouteKind } from './app-data.types';

const CATEGORY_BACKED_ROUTE_PREFIXES = ['/c/hub/', '/gameplay-session/', '/influencer-hub/'];

const NATIVE_API_ALLOWED_ROUTES = new Set([
    '/',
    '/c/explore-videos',
    '/c/new',
    '/c/slots',
    '/c/double-your-bet-category',
    '/c/blackjack',
    '/c/exclusives',
    '/c/classic-reels-category',
    '/c/bonus-buy-category',
    '/c/table',
    '/c/roulette',
    '/c/arcade',
    '/c/all-games',
    '/c/hot-slots',
    '/c/daily-jackpots',
    '/c/favorite-games'
]);

const trimRoute = (currentRoute: string): string => {
    const pathname = currentRoute.split('?')[0] || '/';
    return pathname === '/' ? pathname : pathname.replace(/\/+$/, '');
};

export const isNativeApiAllowedRoute = (currentRoute: string): boolean =>
    NATIVE_API_ALLOWED_ROUTES.has(trimRoute(currentRoute));

export const getAppRouteKind = (currentRoute: string): AppRouteKind => {
    const route = trimRoute(currentRoute);
    if (route === '/') {
        return 'home';
    }
    if (route.startsWith('/game/')) {
        return 'game';
    }
    if (
        route === '/livestream' ||
        route.startsWith('/c/') ||
        CATEGORY_BACKED_ROUTE_PREFIXES.some((prefix) => route.startsWith(prefix))
    ) {
        return 'category';
    }
    if (route.startsWith('/p/')) {
        return 'dynamic';
    }
    return 'static';
};

export const getAppRouteSlug = (currentRoute: string): string => {
    const route = trimRoute(currentRoute);
    const routeKind = getAppRouteKind(route);
    const categoryPrefix =
        route === '/livestream'
            ? '/'
            : (CATEGORY_BACKED_ROUTE_PREFIXES.find((prefix) => route.startsWith(prefix)) ?? '/c/');
    const prefixes: Partial<Record<AppRouteKind, string>> = {
        category: categoryPrefix,
        dynamic: '/p/',
        game: '/game/'
    };
    const prefix = prefixes[routeKind];
    return prefix ? route.slice(prefix.length) : route.slice(1);
};
